
const isProd = true; // change to false for dev

const url = isProd
  ? "https://epportal.hpseb.in/"
  : "https://portald.hpseb.in/";

export default url;
